
<select [(ngModel)]="ladder">
   <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.ladderId}} - {{l.name}}</option>
</select>
<br />
<br />
<button (click)="doit($event)">Print It</button>
